import { Ip } from 'aws-sdk/clients/route53resolver'
import { requestingTripStatuses } from 'src/constants/trip-statuses'
import {
  IPromotion,
  ICreatePromotion,
  IApplyPromotion,
  IAppliedPromotion,
  IPromotionFilter,
  IGetRidersPerPromotion,
  IRiderSearchObject,
  IRiderReponseObject
} from '../types'
import { serverApi } from '../utils/request'

class PromotionsService {
  private urlBase = '/api/v1/promotions'

  public async getPromotions(orgId: string): Promise<{ items: IPromotion[]; count: number }> {
    return (await serverApi.post<{ items: IPromotion[]; count: number }>(`${this.urlBase}`, {
      orgId
    })).data
  }

  public async fetch(params: IPromotionFilter): Promise<{ items: IPromotion[]; count: number }> {
    return (await serverApi.post<{ items: IPromotion[]; count: number }>(`${this.urlBase}`, { ...params })).data
  }

  public async createPromotion(dto: ICreatePromotion): Promise<IPromotion> {
    return (await serverApi.put<IPromotion>(`${this.urlBase}/create`, dto)).data
  }

  public async deletePromotion(promotionId: string): Promise<IPromotion> {
    return (await serverApi.delete<IPromotion>(`${this.urlBase}/${promotionId}`)).data
  }

  public async removePromotionsFromRiders(promotionId: string): Promise<IPromotion> {
    return (await serverApi.delete<IPromotion>(`/api/v1/promotion/riders/${promotionId}`)).data
  }

  public async applyPromotion(dto: IApplyPromotion): Promise<IAppliedPromotion> {
    return (await serverApi.post<IAppliedPromotion>(`${this.urlBase}/apply`, dto)).data
  }

  public async getRidersPerPromotion(params: IGetRidersPerPromotion) {
    return (await serverApi.get<{ items: IRiderReponseObject[]; count: number }>(`${this.urlBase}/riders`, { params }))
      .data
  }

  public async getAppliedPromotions(userId: string): Promise<IAppliedPromotion[]> {
    return (await serverApi.get<IAppliedPromotion[]>(`${this.urlBase}/${userId}`)).data
  }

  public async deleteAppliedPromotion(promotionId: string, walletId: string): Promise<IAppliedPromotion> {
    return (await serverApi.delete<IAppliedPromotion>(`${this.urlBase}/${promotionId}/${walletId}`)).data
  }
}

const promotionsService = new PromotionsService()
export default promotionsService



// WEBPACK FOOTER //
// ./src/services/Promotions.ts